import { Textarea } from '@/components/common/Textarea'
import { StepShell } from '../StepShell'

const SUGGESTIONS = [
  'Pain in lower left back tooth since 5 days',
  'Swelling near upper tooth',
  'Broken tooth',
  'Sensitivity to cold/hot',
]

export function ChiefComplaintStep({ value, onChange, errors = {} }) {
  const v = { complaint_text: '', ...(value || {}) }
  const set = (patch) => onChange?.({ ...v, ...patch })

  return (
    <StepShell
      eyebrow="Section 1 — Phase 3"
      title="Chief complaint"
      description="What brought the patient in today? Capture it in their own words."
    >
      <Textarea
        label="Patient's complaint"
        required
        rows={4}
        value={v.complaint_text}
        onChange={(e) => set({ complaint_text: e.target.value })}
        placeholder="e.g. Pain in lower left back tooth since 5 days"
        error={errors.complaint_text}
      />
      <div>
        <p className="label-text mb-2">Quick suggestions</p>
        <div className="flex flex-wrap gap-1.5">
          {SUGGESTIONS.map((s) => (
            <button
              key={s}
              type="button"
              onClick={() => set({ complaint_text: s })}
              className="rounded-full bg-white px-3 py-1.5 text-xs font-semibold text-ink-700 ring-1 ring-inset ring-ink-200 transition hover:bg-primary-50 hover:text-primary-800 hover:ring-primary-200"
            >
              {s}
            </button>
          ))}
        </div>
      </div>
    </StepShell>
  )
}
